import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogClose } from '../ui/dialog';
import { Leaf } from 'lucide-react';
import { mockServices } from '../../mock/mock';

export const ServicesSection = () => (
  <section id="services" className="services-section">
    <div className="section-container">
      <div className="section-header">
        <span className="section-label">Nos Prestations</span>
        <h2 className="section-title">Les Soins de Laura Body à Angoulême</h2>
      </div>
      <div className="services-grid">
        {mockServices.map((service) => (
          <Card key={service.title} className="service-card">
            <CardHeader>
              <div className="service-icon">{service.icon}</div>
              <CardTitle className="service-title">{service.title}</CardTitle>
              <CardDescription className="service-description">
                {service.description}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="service-benefits">
                {service.benefits.map((benefit) => (
                  <li key={benefit} className="benefit-item">
                    <Leaf className="benefit-icon" />
                    {benefit}
                  </li>
                ))}
              </ul>
              {service.title === 'Massage Bien-être' && (
                <ServiceDialog
                  title="Massage Shirotchampi"
                  description="Massage ayurvédique du cuir chevelu, visage, cou et épaules"
                >
                  <div className="benefit-section">
                    <h3 className="benefit-section-title">Bienfaits physiques :</h3>
                    <ul className="benefit-list">
                      <li>Amélioration de la santé des cheveux et du cuir chevelu</li>
                      <li>Soulagement des maux de tête</li>
                      <li>Détente des tensions musculaires</li>
                      <li>Stimulation de la circulation sanguine</li>
                      <li>Soutien des processus de détoxification</li>
                    </ul>
                  </div>
                  <div className="benefit-section">
                    <h3 className="benefit-section-title">Bienfaits mentaux et émotionnels :</h3>
                    <ul className="benefit-list">
                      <li>Réduction du stress et de l'anxiété</li>
                      <li>Amélioration de la clarté mentale et de la concentration</li>
                      <li>Induction d'un état de calme profond et de relaxation</li>
                      <li>Favorise un sommeil plus réparateur</li>
                    </ul>
                  </div>
                  <div className="info-section">
                    <p>
                      Lors de la séance, une huile végétale est utilisée. Vous aurez le choix entre 
                      une huile de coco ou une huile de pépins de raisin.
                    </p>
                  </div>
                </ServiceDialog>
              )}
              {service.title === 'Réflexologie' && (
                <ServiceDialog
                  title="Séance Réflexologie Plantaire"
                  description="Détente et rééquilibrage énergétique"
                >
                  <div className="benefit-section">
                    <h3 className="benefit-section-title">Les bienfaits de la réflexologie :</h3>
                    <ul className="benefit-list">
                      <li>Gestion du stress</li>
                      <li>Dynamisme de l'organisme</li>
                      <li>Harmonise les fonctions vitales</li>
                      <li>Libère les tensions du dos</li>
                      <li>Améliore la circulation sanguine</li>
                      <li>Apporte détente et relaxation profonde</li>
                      <li>Active le système lymphatique et décontracte les muscles</li>
                      <li>Soulage les troubles du sommeil</li>
                      <li>Soulage les migraines et maux de tête</li>
                      <li>Les ruminations et pensées négatives</li>
                      <li>Gestion des émotions</li>
                    </ul>
                  </div>
                </ServiceDialog>
              )}
              {service.title === 'Naturopathie' && (
                <ServiceDialog
                  title="Consultation Naturopathique"
                  description="Bilan complet personnalisé"
                >
                  <div className="info-section">
                    <p>
                      La naturopathie est une approche de santé holistique qui met l'accent sur la prévention 
                      et le maintien du bien-être global. Elle s'appuie sur des méthodes naturelles et 
                      individualisées afin d'aider chaque personne à retrouver et préserver son équilibre.
                    </p>
                  </div>
                  <div className="benefit-section">
                    <h3 className="benefit-section-title">Ma spécialisation :</h3>
                    <p className="specialization-text">
                      Je me suis spécialisée dans les troubles cutanés, un domaine qui m'a personnellement 
                      concernée. Je sais à quel point ces problématiques peuvent être difficiles à vivre au 
                      quotidien. C'est pourquoi je souhaite mettre mes connaissances et mon expérience au 
                      service de votre mieux-être, afin de vous accompagner pas à pas vers une amélioration 
                      durable de votre peau.
                    </p>
                  </div>
                  <div className="info-section">
                    <p>
                      <strong>Acné, eczéma, psoriasis, rosacée…</strong> si vous êtes concerné(e), vous êtes 
                      au bon endroit. Ensemble, nous chercherons à comprendre l'origine de ces déséquilibres 
                      pour vous aider à retrouver une peau plus saine et un équilibre global.
                    </p>
                  </div>
                </ServiceDialog>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

const ServiceDialog = ({ title, description, children }) => (
  <Dialog>
    <DialogTrigger asChild>
      <Button className="btn-service" variant="outline">En savoir plus</Button>
    </DialogTrigger>
    <DialogContent className="shirotchampi-dialog">
      <DialogHeader>
        <DialogTitle className="dialog-title">{title}</DialogTitle>
        <DialogDescription className="dialog-description">{description}</DialogDescription>
      </DialogHeader>
      <div className="dialog-body">{children}</div>
      <div className="dialog-footer-close">
        <DialogClose asChild>
          <Button className="btn-close-dialog">Fermer</Button>
        </DialogClose>
      </div>
    </DialogContent>
  </Dialog>
);
